import { ContextMenuModule, TreeViewModule } from '@syncfusion/ej2-angular-navigations';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HierarchyManagementComponent } from './hierarchy-management/hierarchy-management.component';
import { HttpClientModule } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { NgModule } from '@angular/core';
import { NgxGraphModule } from '@swimlane/ngx-graph';
import { SvmHierComponent } from './svm-hier.component';

@NgModule({
  declarations: [
    SvmHierComponent,
    HierarchyManagementComponent
  ],
  imports: [
    MatTreeModule,
    MatIconModule,
    TreeViewModule,
    ContextMenuModule,
    MatProgressBarModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    MatSelectModule,
    MatMenuModule,
    MatInputModule,
    MatButtonModule,
    BrowserAnimationsModule,
    MatTableModule,
    MatCardModule,
    NgxGraphModule,
    MatTooltipModule,
   
  ],
  exports: [
    SvmHierComponent
  ]
})
export class SvmHierModule { }
